import { ICertificate } from "../../../models/certificate";
import { getLatinNonLatinCombined, IIDDataSet } from "../../../models/crewMember";
import { CrewMemberImage } from "../../CrewMember/CrewMemberImage";
import coatOfArmsAt from "../../../images/coat_of_arms_at.png";
import { formatDate, riverRangeProps } from "../../../models/common";

type Props = {
    certificate: ICertificate;
    idDataSet: IIDDataSet;
    modifyable: boolean;
};

export const SailingOnWaterwaysCertificateView = ({
    certificate,
    idDataSet,
    modifyable,
}: Props) => {
    return (
        <>
            <p id="tag">Front</p>
            <div className="certificate-front">
                <div className="front-left">
                    <p style={{ fontSize: "15px", fontWeight: "bold" }}>
                        STRECKENZEUGNIS FÜR SCHIFFSFÜHRER AT
                    </p>
                    <p id="positions" style={{ paddingTop: "10px" }}>
                        1.&nbsp;
                        {getLatinNonLatinCombined(idDataSet.nonLatinLastName, idDataSet.lastName)}
                    </p>
                    <p id="positions">
                        2.&nbsp;
                        {getLatinNonLatinCombined(idDataSet.nonLatinFirstName, idDataSet.firstName)}
                    </p>
                    <p id="positions">
                        3.&nbsp;
                        {formatDate(idDataSet.dateOfBirth) +
                            " - " +
                            getLatinNonLatinCombined(
                                idDataSet.nonLatinPlaceOfBirth,
                                idDataSet.placeOfBirth
                            )}
                    </p>
                    <p id="positions" style={{ paddingBottom: "20px" }}>
                        4.&nbsp;{formatDate(certificate.startDate)}
                    </p>
                    <p id="positions">8. Schiffsführerpatent AT</p>
                    <div className="vonbiskm" style={{ paddingBottom: "70px" }}>
                        <p id="positions">9.&nbsp;&nbsp;</p>
                        {certificate.riverKilometers
                            .sort((a, b) => a - b)
                            .map(r => {
                                return riverRangeProps.find(x => x.value === r)?.text ?? "";
                            })
                            .join(", ")}
                    </div>
                </div>
                <div className="front-right">
                    <p style={{ fontSize: "15px", fontWeight: "bold" }}>REPUBLIK ÖSTERREICH</p>
                    <img src={coatOfArmsAt} alt="coatOfArmsAT" id="coatOfArms"></img>
                    <div className="picture">
                        <p style={{ paddingTop: "105px", paddingRight: "4px" }}>6.</p>
                        <div className="picture-frame">
                            <CrewMemberImage imageBase64={idDataSet.imageBase64} />
                        </div>
                    </div>
                    <p style={{ paddingTop: "20px" }}>
                        5. {modifyable ? <em>Wird zugeteilt</em> : certificate.qualificationID}
                    </p>
                </div>
            </div>
            <p id="tag" style={{ paddingTop: "30px" }}>
                Back
            </p>
            <div className="certificate-back">
                <p style={{ textAlign: "center" }}>SCHIFFSFÜHRERZEUGNIS AT</p>
                <p id="positions">
                    1. &nbsp;&nbsp;Name der Inhaberin/des Inhabers, akademischer Grad
                </p>
                <p id="positions">2. &nbsp;&nbsp;Vorname(n)</p>
                <p id="positions">3. &nbsp;&nbsp;Geburtsdatum und -ort</p>
                <p id="positions">4. &nbsp;&nbsp;Ausstellungsdatum des Patents/Zeugnisses</p>
                <p id="positions">5. &nbsp;&nbsp;Ausstellungsnummer</p>
                <p id="positions">6. &nbsp;&nbsp;Lichtbild der Inhaberin/des Inhabers</p>
                <p id="positions">8. &nbsp;&nbsp;Art des Patents</p>
                <p id="positions" style={{ paddingBottom: "20px" }}>
                    9. &nbsp;&nbsp;Örtlicher Geltungsbereich
                </p>
                <p style={{ paddingBottom: "70px" }}>
                    Dieses Streckenzeugnis gilt nur in Verbindung mit dem auf den gleichen Namen
                    lautenden Patent nach 8 und berechtigt den Inhaber zur Fahrt auf den
                    Streckenabschnitten der Donau nach 9
                </p>
            </div>
        </>
    );
};
